import { useSubscription } from './use-subscription';
import { useState, useRef } from 'react';
import { useObservableCallback } from './use-observable-callback';
export function useObservableState(...args) {
    const stateRef = useRef(args[1]);
    const setStateRef = useRef();
    // Record context where the observable subscribed used for easy debugging
    let errorContext;
    if (!errorContext && process.env.NODE_ENV !== 'production') {
        errorContext = new Error('The above error is related to:');
    }
    let callback;
    let states$;
    if (typeof args[0] === 'function') {
        ;
        [callback, states$] = useObservableCallback(args[0]);
    }
    else {
        states$ = args[0];
    }
    useSubscription(states$, state => {
        if (stateRef.current !== state) {
            // assign value before setState
            stateRef.current = state;
            if (setStateRef.current) {
                setStateRef.current(state);
            }
        }
    }, error => {
        console.error(error);
        if (errorContext) {
            console.error(errorContext);
        }
    });
    // Putting useState after subcription will skip re-rendering
    // of all sync emitted values from the Observable.
    setStateRef.current = useState(stateRef.current)[1];
    return callback ? [stateRef.current, callback] : stateRef.current;
}
//# sourceMappingURL=use-observable-state.js.map